// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const LoginView = () => import('@/views/LoginView.vue')
const DashboardView = () => import('@/views/DashboardView.vue')
const VehiclesListView = () => import('@/views/VehiclesListView.vue')
const VehicleDetailView = () => import('@/views/VehicleDetailView.vue')
const ImportFuelView = () => import('@/views/ImportFuelView.vue')
const ReportsView = () => import('@/views/ReportsView.vue')
const MaintenanceTemplatesView = () => import('@/views/MaintenanceTemplatesView.vue')

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
    { path: '/', name: 'dashboard', component: DashboardView, meta: { roles: ['admin','capturista','reportes'] } },
    { path: '/vehicles', name: 'vehicles', component: VehiclesListView, meta: { roles: ['admin','capturista','reportes'] } },
    { path: '/vehicles/:id', name: 'vehicle-detail', component: VehicleDetailView, props: true, meta: { roles: ['admin','capturista','reportes'] } },
    { path: '/import', name: 'import', component: ImportFuelView, meta: { roles: ['admin','capturista'] } },
    { path: '/reports', name: 'reports', component: ReportsView, meta: { roles: ['admin','reportes'] } }, // 👈 coma aquí
   // { path: '/maintenance/templates', name: 'maintenance-templates', component: MaintenanceTemplatesView, meta: { roles: ['admin','capturista','reportes'] } },
    { path: '/maintenance/templates',  name: 'maintenance-templates',  component: () => import('@/views/MaintenanceTemplatesView.vue')},    
    { path: '/reports/maintenance',  name: 'reports-maintenance',  component: () => import('@/views/MaintenanceEventsReportView.vue'),  meta: { requiresAuth: true }},
    { path: '/admin/users',  name: 'users',  component: () => import('@/views/UsersView.vue'),  meta: { requiresAuth: true, onlyAdmin: true }},
    { path: '/repairs/:id/evidences', name: 'RepairEvidences', component: () => import('@/components/RepairEvidences.vue'), props: route => ({ repairId: Number(route.params.id) }),
  meta: { requiresAuth: true, roles: ['admin','capturista','reportes'] }},
    { path: '/deposits', name: 'deposits', component: () => import('@/views/DepositsView.vue'), meta: { requiresAuth: true, title: 'Depósitos' }},

    // Opcional: catch-all para 404
    { path: '/:pathMatch(.*)*', redirect: { name: 'dashboard' } } ],
  // Opcional: comportamiento de scroll
  scrollBehavior () {
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const auth = useAuthStore()

  // fallback rápido por si el guard corre antes de restoreFromStorage()
  if (!auth.token) {
    const t = localStorage.getItem('token')
    if (t) auth.token = t
  }

  // si ya hay sesión y va a /login, manda al dashboard
  if (to.name === 'login' && auth.token) return next({ name: 'dashboard' })

  // rutas públicas
  if (to.meta.public) return next()

  // requiere auth
  if (!auth.token) return next({ name: 'login', query: { r: to.fullPath } })

  // si la ruta define roles, valida
  if (to.meta.roles && Array.isArray(to.meta.roles)) {
    const rol = auth.user?.rol
    if (!rol || !to.meta.roles.includes(rol)) {
      return next({ name: 'dashboard' })
    }
  }

  next()
})

export default router
